import { defineMessages } from 'react-intl';

export const heidi2OptInModalMessages = defineMessages({
  title: {
    defaultMessage: 'Heidi II early access',
    id: '1wO+j3Xm3J',
    description: 'Title of the Heidi II opt-in modal',
  },
  heading: {
    defaultMessage: 'Heidi listens, writes, answers, and now acts.',
    id: 'K1XlDU1CCo',
    description: 'Heading of the Heidi II opt-in modal',
  },
  handOffTasks: {
    defaultMessage: 'Hand off tasks. Review what Heidi brings back.',
    id: 'aTbJFka2XM',
    description: 'Heidi II opt-in benefit about handing off work',
  },
  saveRoutines: {
    defaultMessage: 'Save recurring work as routines.',
    id: 'e8kLHWLXzc',
    description: 'Heidi II opt-in benefit about routines',
  },
  currentPlan: {
    defaultMessage: 'Pay the same as your current plan.',
    id: 'E2liVOLCZF',
    description: 'Heidi II opt-in benefit about current plan pricing',
  },
  termsPrefix: {
    defaultMessage: 'I agree to the ',
    id: 'eZPCCAoYj4',
    description: 'Text before the terms of use action in the Heidi II opt-in modal',
  },
  termsAction: {
    defaultMessage: 'terms of use',
    id: 'jXHITzut4w',
    description: 'Action opening the Heidi II terms of use modal',
  },
  termsSuffix: {
    defaultMessage:
      '. By starting Heidi II you’ll have 30 days of complimentary unlimited usage of Heidi agentic tasks. After complimentary period ends, usage limits included in your plan apply. Your plan price remains the same.',
    id: 'kSzb8ZS93G',
    description: 'Usage disclosure following the Heidi II terms agreement',
  },
  start: {
    defaultMessage: 'Start using Heidi II',
    id: 'EGeUzUBexL',
    description: 'CTA accepting the Heidi II terms and activating Heidi II',
  },
  acceptTermsError: {
    defaultMessage: 'Accept terms of use to continue',
    id: '7AvuzBIQVB',
    description: 'Error shown when Heidi II activation is attempted without consent',
  },
  activationError: {
    defaultMessage: 'Couldn’t start Heidi II. Try again.',
    id: '3sGdZyW9A9',
    description: 'Error shown when Heidi II activation fails',
  },
  termsTitle: {
    defaultMessage: 'Heidi II terms of use',
    id: 'VKaBWzp62J',
    description: 'Title of the Heidi II terms of use modal',
  },
  termsBody: {
    defaultMessage:
      'This Usage Policy outlines the terms and conditions governing the acceptable use of the Heidi Platform developed by and operated by Heidi Health Trading Pty Limited (ABN 84 649 783 871) (Heidi, we, us, our) and our affiliates. The Heidi Platform is designed to provide support in the delivery of health services, including clinical workflow management, access to medical information about patients, and AI-powered evidence synthesis from peer-reviewed clinical studies and clinical-practice guidelines. The Heidi Platform integrates AI functionality to support administrative and clinical decision-making processes, including clinical decision support tools, and serves as a tool for assisting in the delivery of telehealth services through telephone, video, and chat functionality.',
    id: '9hyEY5xIa0',
    description: 'Placeholder legal copy in the Heidi II terms of use modal',
  },
  closeTerms: {
    defaultMessage: 'Close',
    id: 'aKWXxsT/oM',
    description: 'CTA closing the Heidi II terms of use modal',
  },
});
